<main role="main" class="flex-shrink-0">
<div class="container-fluid mt-3 mb-4">
<div class="row pb-2">
  <div class="col">
      <h4><i class="fas fa-sign-out-alt"></i> You logged out of your account.</h4>
  </div>
</div>
<div class="row">
  <div class="col">
      <p class="text-left">Thank you for using ACES. It's a good idea to close all
          browser windows.<br/>Click the login button below to authenticate yourself and login to the system again.
      </p>
  </div>
</div>
<div class="row">
  <div class="col">
      <button type="button" class="btn btn-success" [routerLink]="['/login']"><i class="fas fa-sign-in-alt"></i> Login</button>
  </div>
</div>
</div>
</main>